<template>
  <b-overlay :show="loading">
    <b-form id="form-entity" data-vv-scope="form-entity">
      <div class="row">
        <div class="col-md-12 scroll-area">
          <ul class="list-group mt-5">
            <li
              v-for="service in entityServices"
              class="list-group-item"
              :key="service.id"
            >
              <div class="row">
                <div class="col-md-10">
                  <h6 v-b-tooltip="service.name">
                    {{ service.name }}
                  </h6>
                  <small class="text-muted">
                    {{ service.code }}
                  </small>
                </div>
                <div class="col-md-2">
                  <b-form-checkbox
                    switch
                    size="lg"
                    :value="true"
                    :unchecked-value="false"
                    v-model="service.selected"
                  ></b-form-checkbox>
                </div>
              </div>

            </li>
          </ul>
        </div>
      </div>
    </b-form>
    <vs-divider></vs-divider>
    <div class="text-right">
      <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        v-on:click="attemptSaveEntityServices"
        data-cy="save-entity"
      >
        Guardar
      </b-button>
    </div>
  </b-overlay>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  data() {
    return {
      selectedEntity: {},
      entityUsers: [],
      entityServices: [],
      costsCenter: [],
      currentEntityServices: [],
      loading: false
    };
  },
  props: {
    entity: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('Materials', [
      'services'
    ]),
  },
  methods: {
    ...mapActions('Materials', [
      'getServices',
      'editEntity'
    ]),
    async attemptSaveEntityServices() {
      const result = await this.$validator.validateAll('form-entity');
      if (!result) {
        return;
      }
      const extraData = {
        ...this.entity.extra,
        servicios: this.entityServices
          .filter((service) => service.selected)
          .map((service) => ({
            id: service.id,
            codigo: service.code,
            nombre: service.name
          }))
      };
      const body = {
        descripcion: this.selectedEntity.name,
        opcionId: this.entity.optionId,
        padre: this.entity.padre,
        grupoId: this.entity.groupId,
        parametroId: this.entity.parameterId,
        nivel: this.entity.levelNode,
        extra: JSON.stringify(extraData)
      };
      await this.editEntity(body);
      this.$emit('edited');
    },
    verifyService(serviceId) {
      return (this.currentEntityServices
        .some((service) => service === serviceId));
    },
    async fetchServices() {
      await this.getServices({
        grupoOpcion: 'io.solicitud.material.servicios',
        filtros: 'deshabilitado:0'
      });
      if (this.entity.extra.servicios) {
        this.currentEntityServices = this.entity.extra.servicios
          .map((service) => service.id);
      }
      this.entityServices = this.services
        .map((service) => ({
          id: service.opcionId,
          name: service.descripcion,
          code: service.valor,
          selected: this.verifyService(service.opcionId)
        }));
    },
  },
  async mounted() {
    this.fetchServices();
  }
};
</script>
